import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';

import AddCatalogsCodeForm from '../../components/AddCatalogsCodeForm';
import SubviewContainer from '../../components/SubviewContainer';
import OverLayLoader from '../../components/OverLayLoader';

import { createCode, getLanguages, addCodeToProfile } from '../../services';
import { createErrorNotification } from '../../utils/createErrorNotification';
import useTitle from '../../hooks/useTitle';
import PATH from '../../helpers/routes.json';
import statusCodes from '../../utils/statusCodes';
import { useAuth } from '../../context/auth/AuthContext';

const AddCatalogsCodeView = () => {
  const [languages, setLanguages] = useState([]);
  const [profiles, setProfiles] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();
  const { state } = useLocation();

  const { user } = useAuth();

  const { t } = useTranslation('promptbar');

  const title = t('promptbar:addCode');
  const pageTitle = t('promptbar:pageTitle', {
    title,
  });

  useTitle(pageTitle);

  const gotoPath = state
    ? `${state.pathname + state.search}`
    : PATH.diagnoses.primary;

  useEffect(() => {
    if (!user) {
      return;
    }

    const fetchData = async () => {
      try {
        setIsLoading(true);
        const [langs] = await Promise.all([getLanguages()]);

        setLanguages(langs.data);
        setProfiles(user.profiles);
      } catch (error) {
        console.log(error.message);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, [user]);

  const formSubmitHandler = async (data, codeId) => {
    try {
      setIsLoading(true);

      if (codeId) {
        await addCodeToProfile(codeId, data);
      } else {
        await createCode(data);
      }

      navigate(gotoPath);
    } catch (error) {
      if (
        error?.response?.status === statusCodes.HTTP_422_UNPROCESSABLE_ENTITY &&
        typeof error?.response?.data?.detail === 'string'
      ) {
        createErrorNotification(error.response.data.detail);
      } else {
        createErrorNotification();
      }

      console.log(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const cancelHandler = () => {
    navigate(gotoPath);
  };

  return (
    <>
      {isLoading && <OverLayLoader />}{' '}
      <SubviewContainer title={title}>
        <Box sx={{ padding: '3rem 2rem 2rem' }}>
          <AddCatalogsCodeForm
            onCancel={cancelHandler}
            onSubmit={formSubmitHandler}
            languages={languages}
            profiles={profiles}
          />
        </Box>
      </SubviewContainer>
    </>
  );
};

export default AddCatalogsCodeView;
